
export default {

  authenticityToken() {
    const token = document.querySelector('meta[name="csrf-token"]');
    if (token && (token instanceof window.HTMLMetaElement)) {
      return token.content;
    }
    return null;
  },

  authenticityHeaders(otherHeaders = {}) {
    const token = this.authenticityToken();
    return Object.assign(otherHeaders, {
      'X-CSRF-Token': token,
      'X-Requested-With': 'XMLHttpRequest',
    });
  },
};
